<template>
    <div>
        <div class="mb-4 text-right">
            <button
                class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-3 rounded-full text-followup-nav"
                @click="expandAll" type="button">
                Expand All
            </button>

            <button
                class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-3 rounded-full text-followup-nav"
                @click="contractAll" type="button">
                Contract All
            </button>
        </div>


        <div v-for="(data, index) in reportData">
        <report-card-row   :button="false" first="Id" second="Project Quantity" third="Base Bid"
                         fourth="Contract Amount"></report-card-row>
        <report-card-row :button="data.total_projects_on_behaviors > 0" :yellow="true" :first="data.short_description" :second="data.total_projects_on_behaviors" class="mb-4">
            <report-card-row v-for="(project, index) in data.projects_management" :key="index" :button="false"
                             :white="index % 2 !== 0" :first="project.custom_project_id ? project.custom_project_id : project.sequential_team_id" :second="project.name"
                             :third="project.base_bid" :fourth="project.contract_amount"
                             :project_management="project.id"></report-card-row>
        </report-card-row>

        </div>

        <report-card-row :button="1 > 0" :yellow="true"
                         first="Project Management Behaviors "  >
            <report-card-row :button="false" first="Management Stages" third="Qty Bids"></report-card-row>
            <div v-for="(data, index) in managementBehaviour" :key="'managementBehaviour'+index">

                <report-card-row :button="data.length > 0" :yellow="true"
                                 :first="index" :third="data.length">
                    <report-card-row v-for="(project_management_behaviour, index) in data" :key="index"
                                     :button="project_management_behaviour.project_managements.length > 0" :first="project_management_behaviour.name"
                                     :third="project_management_behaviour.project_managements.length" :fourth="project_management_behaviour.hours">
                        <report-card-row :button="false" first="Date" second="ID" third="Project Name"
                                         fourth="Contract Amount" five="Hours"></report-card-row>
                        <report-card-row v-for="(project_b, index) in project_management_behaviour.project_managements" :key="index"
                                         :button="false" :white="index % 2 === 0" :first="formatDate(project_b.pivot.date)"
                                         :second="project_b.project.custom_project_id ? project_b.project.custom_project_id : project_b.project.sequential_team_id"
                                         :third="project_b.project.name"
                                         :fourth="showContract(project_b.contract_amt)"
                                         :five="project_management_behaviour.value"
                                         :project_management="project_b.project.id"></report-card-row>
                    </report-card-row>
                </report-card-row>

            </div>

        </report-card-row>
    </div>
</template>

<script>
import ReportCardRow from "../report-card-row";
import moment from 'moment';
export default {
    components: {ReportCardRow},
    props     : ['reportData','managementBehaviour','projects_milestones', 'masks'],
    methods: {
        formatDate(value) {
            if (value) {
                return moment(String(value)).format('MM/DD/YYYY')
            }
        },

        expandAll() {
            let add = document.getElementsByName("plus");
            add.forEach((plus) => {
                plus.click();
            });
            Vue.nextTick(() => {
                let add = document.getElementsByName("plus");
                add.forEach((plus) => {
                    plus.click();
                });
                Vue.nextTick(() => {
                    let add = document.getElementsByName("plus");
                    add.forEach((plus) => {
                        plus.click();
                    });
                });
            });
        },

        showContract(contract){

            var formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',

                // These options are needed to round to whole numbers if that's what you want.
                //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
                //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
            });
            return formatter.format(contract/100);//'$'+contract/100;
        },
        contractAll() {
            let subtract = document.getElementsByName("minus");
            subtract.forEach((minus) => {
                minus.click();
            });
        }
    },
    data() {
        return {
            totalHours: 0,
        }
    }
}
</script>

